(() => {
  let instance = 0;
  function enhance(bar) {
    if (bar.dataset.lcdSearchReady) return;
    bar.dataset.lcdSearchReady = 'true';
    const input = bar.querySelector('input[type="search"]');
    const panel = bar.querySelector('.search-bar__result');
    const content = bar.querySelector('.search-bar__result-content');
    if (!input || !panel || !content) return;
    const id = `lcd-search-results-${++instance}`;
    content.id = id;
    content.setAttribute('role', 'listbox');
    content.setAttribute('aria-label', bar.dataset.lcdSearchLabel);
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-label', bar.dataset.lcdSearchLabel);
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', id);
    input.setAttribute('aria-expanded', 'false');
    let timer, controller, selection = -1;
    function close() {
      clearTimeout(timer);
      controller?.abort();
      panel.classList.add('hide');
      panel.classList.remove('active', 'loading');
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      selection = -1;
    }
    function select(index) {
      const options = [...content.querySelectorAll('[role="option"]')];
      if (!options.length) return;
      selection = (index + options.length) % options.length;
      options.forEach((option, i) => option.setAttribute('aria-selected', String(i === selection)));
      input.setAttribute('aria-activedescendant', options[selection].id);
      options[selection].scrollIntoView({ block: 'nearest' });
    }
    async function search(query) {
      controller?.abort();
      controller = new AbortController();
      const requestController = controller;
      const url = new URL(`${bar.dataset.lcdSearchUrl}/suggest.json`, location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '6');
      try {
        const response = await fetch(url, { signal: requestController.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (requestController.signal.aborted || input.value.trim() !== query) return;
        content.replaceChildren();
        selection = -1;
        input.removeAttribute('aria-activedescendant');
        for (const [i, product] of (data.resources?.results?.products || []).entries()) {
          const href = new URL(product.url, location.origin);
          if (href.origin !== location.origin) continue;
          const link = document.createElement('a');
          link.href = href.href;
          link.className = 'lcd-search-product';
          link.id = `${id}-${i}`;
          link.setAttribute('role', 'option');
          link.setAttribute('aria-selected', 'false');
          if (product.image) {
            const image = document.createElement('img');
            const src = new URL(product.image, location.origin);
            if (src.protocol === 'https:' || src.protocol === 'http:') {
              src.searchParams.set('width', '120');
              image.src = src.href;
              image.alt = '';
              image.width = 60;
              image.height = 60;
              image.loading = 'lazy';
              link.append(image);
            }
          }
          const details = document.createElement('span');
          const title = document.createElement('span');
          title.textContent = product.title;
          details.append(title);
          if (product.price !== null && product.price !== undefined && Number.isFinite(Number(product.price))) {
            const price = document.createElement('strong');
            price.textContent = new Intl.NumberFormat(bar.dataset.lcdLocale || 'fr-FR', { style: 'currency', currency: bar.dataset.lcdCurrency || 'EUR' }).format(Number(product.price));
            details.append(price);
          }
          link.append(details);
          content.append(link);
        }
        if (!content.childElementCount) { close(); return; }
        panel.classList.remove('hide', 'loading');
        panel.classList.add('active');
        input.setAttribute('aria-expanded', 'true');
      } catch (error) {
        if (error.name !== 'AbortError' && controller === requestController) close();
      }
    }
    input.addEventListener('input', () => {
      close();
      content.replaceChildren();
      const query = input.value.trim();
      if (query.length >= 2) timer = setTimeout(() => search(query), 250);
    });
    input.addEventListener('keydown', event => {
      if (event.key === 'Escape') { close(); return; }
      if (input.getAttribute('aria-expanded') !== 'true') return;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); select(selection + (event.key === 'ArrowDown' ? 1 : -1)); }
      if (event.key === 'Enter' && selection >= 0) { event.preventDefault(); content.querySelectorAll('[role="option"]')[selection]?.click(); }
    });
    bar.querySelector('.search-bar__button-close')?.addEventListener('click', close);
    document.addEventListener('click', event => { if (!bar.contains(event.target)) close(); });
    bar.addEventListener('focusout', () => { setTimeout(() => { if (!bar.contains(document.activeElement)) close(); }, 0); });
  }
  function initialise(root) { root.querySelectorAll('search-bar[data-lcd-search-url]').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document));
  else initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
